import $api from "http/index";

const HR = "employees/hr/";

export const listEmployees = (params) => $api.get(`${HR}employees/`, { params });
export const getEmployee = (id) => $api.get(`${HR}employees/${id}/`);
export const updateEmployee = (id, data) => $api.patch(`${HR}employees/${id}/`, data);
export const deleteEmployee = (id) => $api.delete(`${HR}employees/${id}/`);
export const hireEmployee = (data) => $api.post(`${HR}employees/hire/`, data);
export const transferEmployee = (id, data) => $api.post(`${HR}employees/${id}/transfer/`, data);
export const dismissEmployee = (id, data) => $api.post(`${HR}employees/${id}/dismiss/`, data);
export const employeeAssignments = (id) => $api.get(`${HR}employees/${id}/assignments/`);
export const employeeContracts = (id) => $api.get(`${HR}employees/${id}/contracts/`);

export const listAssignments = (params) => $api.get(`${HR}assignments/`, { params });
export const createAssignment = (data) => $api.post(`${HR}assignments/`, data);
export const updateAssignment = (id, data) => $api.patch(`${HR}assignments/${id}/`, data);
export const deleteAssignment = (id) => $api.delete(`${HR}assignments/${id}/`);

export const listContracts = (params) => $api.get(`${HR}contracts/`, { params });
export const createContract = (data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => {
    if (v !== undefined && v !== null) fd.append(k, v);
  });
  return $api.post(`${HR}contracts/`, fd);
};
export const updateContract = (id, data) => $api.patch(`${HR}contracts/${id}/`, data);
export const deleteContract = (id) => $api.delete(`${HR}contracts/${id}/`);
export const listMovements = (params) => $api.get(`${HR}movements/`, { params });
